module.exports = __webpack_public_path__ + "img/company-logo-dark.7aded17e.svg";